import { DUTCH_DATE_PROVIDERS } from '../../core/utils/dutch-date-providers';
import { Component, Injector, Input, OnInit, Optional, ChangeDetectionStrategy } from '@angular/core';
import { UserLoginHistory, UserLoginHistoryService } from '@mango/authentication';
import { createColumnDefinitions, Filter, PagedCollectionComponent, SearchableType, ColumnDefinition, MgTableComponent } from '@mango/core';
import { User } from 'src/app/user/user';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import { MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell } from '@angular/material/table';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'user-login-history-collection',
    templateUrl: 'login-history-collection.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MgTableComponent, MatSort, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatSortHeader, MatCellDef, MatCell, DatePipe],
    providers: [...DUTCH_DATE_PROVIDERS]
})

export class UserLoginHistoryCollectionComponent extends PagedCollectionComponent<UserLoginHistory> {

    columnDefinitions: ColumnDefinition[] = createColumnDefinitions<UserLoginHistory>([
        { prop: 'date', searchable: SearchableType.Date },
        { prop: 'ipAddress', searchable: SearchableType.String },
    ]);

    displayedColumns = this.columnDefinitions.map(x => x.colDef);

    constructor(public service: UserLoginHistoryService, @Optional() injector: Injector, @Optional() protected filter: Filter<UserLoginHistory>) {
        super('/userLoginHistories', UserLoginHistory);

        if (!this.filter) {
            this.filter = new Filter<UserLoginHistory>();
        }

        this.initInput('user', this.filterBuilder.equal(x => x.user.id));
    }

    @Input() set user(val: User) {
        this.handleInput('user', val.id);
    }

    ngOnInit() {
        super.ngOnInit();
    }
}
